// extracted by mini-css-extract-plugin
module.exports = {"Badge":"styles_Badge__3J8Dt"};